module.exports = "/matchcenter-staging/assets/images/novasport_3.9434046f2343efb1d56f17ada567896d.png";